var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherSunDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.501C14.4853 16.501 16.5 14.4863 16.5 12.001C16.5 9.5157 14.4853 7.50098 12 7.50098C9.51472 7.50098 7.5 9.5157 7.5 12.001C7.5 14.4863 9.51472 16.501 12 16.501Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.827C12.5523 5.827 13 5.37928 13 4.827V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V4.827C11 5.37928 11.4477 5.827 12 5.827Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.175C11.4477 18.175 11 18.6228 11 19.175V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V19.175C13 18.6228 12.5523 18.175 12 18.175Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.219 7.63594C6.61344 8.01668 7.23856 8.01668 7.633 7.63594C8.02338 7.24544 8.02338 6.61244 7.633 6.22194L4.933 3.51494C4.54226 3.12337 3.90807 3.1227 3.5165 3.51344C3.12493 3.90418 3.12426 4.53837 3.515 4.92994L6.219 7.63594Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.779 16.366C17.3866 15.9871 16.7629 15.9925 16.3772 16.3782C15.9914 16.764 15.986 17.3877 16.365 17.78L19.071 20.487C19.4652 20.8683 20.0908 20.8683 20.485 20.487C20.8754 20.0965 20.8754 19.4635 20.485 19.073L17.779 16.366Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.826 12.5C5.826 11.9477 5.37828 11.5 4.826 11.5H1C0.447715 11.5 0 11.9477 0 12.5C0 13.0523 0.447715 13.5 1 13.5H4.826C5.37828 13.5 5.826 13.0523 5.826 12.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5H19.174C18.6217 11.5 18.174 11.9477 18.174 12.5C18.174 13.0523 18.6217 13.5 19.174 13.5H23C23.5523 13.5 24 13.0523 24 12.5C24 11.9477 23.5523 11.5 23 11.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.219 16.366L3.519 19.073C3.12862 19.4635 3.12862 20.0965 3.519 20.487C3.91323 20.8683 4.53877 20.8683 4.933 20.487L7.633 17.781C8.01197 17.3886 8.00655 16.7649 7.62082 16.3792C7.23508 15.9935 6.61138 15.988 6.219 16.367V16.366Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.072 7.92299C17.3363 7.92453 17.5905 7.82134 17.779 7.63599L20.485 4.92999C20.8757 4.53953 20.876 3.90623 20.4855 3.51549C20.095 3.12475 19.4617 3.12453 19.071 3.51499L16.365 6.22199C16.0779 6.5065 15.9917 6.93652 16.1469 7.30971C16.3021 7.68291 16.6678 7.92497 17.072 7.92199V7.92299Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherSunDark);
export default __webpack_public_path__ + "static/media/weatherSunDark.5056a0c3.svg";
export { ForwardRef as ReactComponent };